<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <b-card>
          <b-form-group style="text-align: left;" label="">
            <h4>Usage cheatsheet :</h4>
            <ol>
              <li>Check your settings</li>
              <li>Copy items from in-game hangar</li>
              <li>Paste items in textbox</li>
              <li>Click "Parse items"</li>
              <li>Input unit prices manually or click "Import EveMarketer Prices"</li>
            </ol>
            <p>Result : <br />Items in red are not worth recycling and should just be sold as is.<br /> The totals of
              the
              reprocessing is also displayed in the 2nd table.</p>
          </b-form-group>
        </b-card>
      </b-col>
      <b-col col lg="10">
        <b-card>
          <b-button v-b-toggle.settings variant="primary">Settings</b-button>
          <b-collapse id="settings">
            <b-form-group label="Market Data Fetch">
              <b-row>
                <b-col>
                  <!-- Location Selection -->
                  <b-form-group label="Location">
                    <b-form-radio-group v-model="settings.market_scope_choice" @change="
                      $store.commit(
                        'CHANGE_MARKET_SCOPE_CHOICE',
                        settings.market_scope_choice
                      );
                    fetchPrices();
                    " stacked>
                      <b-row class="mb-2">
                        <b-col class="d-flex align-items-center justify-content-end">
                          <b-form-radio value="global">Global</b-form-radio>
                        </b-col>
                        <b-col></b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col class="d-flex align-items-center justify-content-end">
                          <b-form-radio value="region">Region</b-form-radio>
                        </b-col>
                        <b-col>
                          <b-form-select v-model="settings.market_region" :options="mapRegions" value-field="regionID"
                            text-field="regionName" @change="
                      $store.commit(
                        'CHANGE_MARKET_REGION',
                        settings.market_region
                      );
                    fetchPrices();
                    "></b-form-select>
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col class="d-flex align-items-center justify-content-end">
                          <b-form-radio value="system"> System </b-form-radio>
                        </b-col>
                        <b-col>
                          <b-form-select v-model="settings.market_system" :options="mapSystems
                      .filter((x) => x.regionID == settings.market_region)
                      .sort((a, b) =>
                        a.solarSystemName > b.solarSystemName
                          ? 1
                          : b.solarSystemName > a.solarSystemName
                            ? -1
                            : 0
                      )
                      " value-field="solarSystemID" text-field="solarSystemName" @change="
                      $store.commit(
                        'CHANGE_MARKET_SYSTEM',
                        settings.market_system
                      );
                    fetchPrices();
                    "></b-form-select>
                        </b-col>
                      </b-row>
                    </b-form-radio-group>
                  </b-form-group>
                  <!-- End location selection -->
                </b-col>
                <b-col>
                  <!-- Prices Settings -->
                  <b-form-group label="Prices">
                    <b-row class="mb-2">
                      <b-col class="d-flex align-items-center justify-content-end">
                        <label for="market_type">Type : </label>
                      </b-col>
                      <b-col>
                        <b-form-select id="market_type" v-model="settings.market_type" :options="marketTypes" @change="
                      $store.commit(
                        'CHANGE_MARKET_TYPE',
                        settings.market_type
                      );
                    fetchPrices();
                    "></b-form-select>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col class="d-flex align-items-center justify-content-end">
                        <label for="market_price">Price : </label>
                      </b-col>
                      <b-col>
                        <b-form-select id="market_price" v-model="settings.market_price" :options="marketPrices"
                          @change="
                      $store.commit(
                        'CHANGE_MARKET_PRICE',
                        settings.market_price
                      );
                    fetchPrices();
                    "></b-form-select>
                      </b-col>
                    </b-row>
                  </b-form-group>
                  <!-- End Prices Settings -->
                </b-col>
              </b-row>
            </b-form-group>

            <b-form-group label="Reprocessing">
              <label for="reprocessing_yield">Yield <b-icon icon="question-circle-fill"
                  @click="router.push('/help')"></b-icon></label>
              <input-percent id="reprocessing_yield" v-model="settings.rYield" @input="
                      Object.keys(expectedRM).forEach((key) => {
                        updateRMTotals(key);
                      });
                    $store.commit('CHANGE_REPROCESSING_YIELD', settings.rYield);
                    " />
            </b-form-group>
          </b-collapse>
        </b-card>
        <b-card>
          <b-form-group label="Items to reprocess" style="margin-bottom: 0">
            <b-row style="margin-bottom: 0.5rem">
              <b-form-textarea size="sm" placeholder="Input items to reprocess here" @keydown="textAreaSpecialKeys"
                v-model="inputRITextArea"></b-form-textarea>
            </b-row>
            <b-row>
              <b-col>
                <b-button variant="primary" @click="searchForItems">
                  Parse Items
                </b-button>
              </b-col>
              <b-col>
                <b-button variant="primary" @click="fetchPrices">
                  Import Fuzzwork's Prices
                </b-button>
              </b-col>
            </b-row>
          </b-form-group>
        </b-card>
        <section>
          <!-- Reprocessed Items Table -->
          <h1 class="mt-3">Reprocessed Items</h1>
          <b-table ref="itemsList" :items="Object.values(reprocessedItems)" :fields="RIFields" :sort-by.sync="RISortBy"
            :sort-desc.sync="RISortDesc" :sort-direction="RISortDirection">
            <template #cell(img)="data">
              <img :src="`https://imageserver.eveonline.com/Type/${data.item.typeID}_64.png`" />
            </template>

            <template #cell(name)="data">
              {{ data.item.name }}
            </template>

            <template #cell(quantity)="data">
              <b-form-input type="number" v-model="reprocessedItems[data.item.typeID].quantity"
                @input="updateRIQuantity(data.item.typeID)" />
            </template>

            <template #cell(price)="data">
              <b-input-group>
                <b-form-input type="number" v-model="reprocessedItems[data.item.typeID].price"
                  @input="updateRITotals(data.item.typeID)" />
                <b-input-group-append>
                  <b-input-group-text>ISK</b-input-group-text>
                </b-input-group-append>
              </b-input-group>
            </template>

            <template #cell(cachedTotalVolume)="data">
              {{ data.value.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}<TrailSpan>m<sup>3</sup>
              </TrailSpan>
            </template>

            <template #cell(actions)="data">
              <b-button size="sm" @click="removeRI(data.item.typeID)" variant="danger">
                <b-icon-x></b-icon-x>
              </b-button>
            </template>

            <!-- Other columns -->
            <template #cell()="data">
              {{ data.value.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}<TrailSpan>ISK</TrailSpan>
            </template>
            <!-- Footer with totals -->
            <template #custom-foot="data">
              <b-tr>
                <b-th :colspan="data.columns - 4" class="align-right">Totals</b-th>
                <b-th>
                  {{
                      totalRICost.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })
                    }}<TrailSpan>ISK</TrailSpan>
                </b-th>
                <b-th>
                  {{
                        totalRMPrice.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                        })
                      }}<TrailSpan>ISK</TrailSpan>
                </b-th>
                <b-th>
                  {{
                        Object.values(reprocessedItems)
                          .map((x) => x.quantity * x.volume)
                          .reduce((a, b) => a + b, 0)
                          .toLocaleString(undefined, { minimumFractionDigits: 2 })
                      }}<TrailSpan>m<sup>3</sup></TrailSpan>
                </b-th>
              </b-tr>
            </template>
          </b-table>
        </section>
        <section>
          <!-- Reprocessed Materials Table -->
          <h1 class="mt-3">Expected Materials</h1>
          <b-table :items="Object.values(expectedRM)" :fields="RMFields" :sort-by.sync="RMSortBy"
            :sort-desc.sync="RMSortDesc" :sort-direction="RMSortDirection">
            <template #cell(img)="data">
              <img :src="`https://imageserver.eveonline.com/Type/${data.item.typeID}_64.png`" />
            </template>
            <template #cell(name)="data">
              {{ data.item.name }}
            </template>

            <template #cell(price)="data">
              <b-input-group>
                <b-form-input type="number" v-model="expectedRM[data.item.typeID].price"
                  @input="updateRMTotals(data.item.typeID)" />
                <b-input-group-append>
                  <b-input-group-text>ISK</b-input-group-text>
                </b-input-group-append>
              </b-input-group>
            </template>

            <template #cell(cachedQuantity)="data">
              {{ data.value.toLocaleString(undefined) }}
            </template>

            <template #cell()="data">
              {{
                      data.value.toLocaleString(undefined, { minimumFractionDigits: 2 })
                    }}<TrailSpan>ISK</TrailSpan>
            </template>
            <!-- Footer with totals -->
            <template #custom-foot="data">
              <b-tr>
                <b-th :colspan="data.columns - 2" class="align-right">Totals</b-th>
                <b-th>{{
                      totalRMPrice.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })
                    }}<TrailSpan>ISK</TrailSpan>
                </b-th>
                <b-th>{{
                        Object.values(expectedRM)
                          .map((x) => x.cachedTotalVolume)
                          .reduce((a, b) => a + b, 0)
                          .toLocaleString(undefined, { minimumFractionDigits: 2 })
                      }}<TrailSpan>m<sup>3</sup></TrailSpan>
                </b-th>
              </b-tr>
              <b-tr>
                <b-th :colspan="data.columns - 2" class="align-right">Market Costs</b-th>
                <b-th>{{
                      totalRICost.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })
                    }}<TrailSpan>ISK</TrailSpan>
                </b-th>
              </b-tr>
              <b-tr>
                <b-th :colspan="data.columns - 2" class="align-right">Profit / Losses</b-th>
                <b-th :variant="totalRMPrice < 0 ? 'danger' : totalResult > 0 ? 'success' : ''
                      ">{{
                      totalResult.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })
                    }}<TrailSpan>ISK</TrailSpan>
                </b-th>
                <b-th></b-th>
              </b-tr>
            </template>
          </b-table>
        </section>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Papa from "papaparse";
import axios from "axios";
import PercentageComponent from "./PercentageInput";
import TrailSpan from "./TrailSpan";

export default {
  components: {
    TrailSpan,
    "input-percent": PercentageComponent,
  },
  data: function () {
    return {
      loading: false,

      router: this.$router,
      //Settings variables
      //Initially pulled from Vuex storage
      settings: {
        market_scope_choice: this.$store.state.settings.market_scope_choice,
        market_region: this.$store.state.settings.market_region,
        market_system: this.$store.state.settings.market_system,
        market_type: this.$store.state.settings.market_type,
        market_price: this.$store.state.settings.market_price,
        rYield: this.$store.state.settings.r_yield,
      },
      //Available prices from market
      marketTypes: [
        { value: "buy", text: "Buy" },
        { value: "sell", text: "Sell" },
      ],
      marketPrices: [
        { value: "weightedAverage", text: "Weighted Average" },
        { value: "median", text: "Median" },
        { value: "percentile", text: "Percentile" },
        { value: "min", text: "Minimum" },
        { value: "max", text: "Maximum" },
      ],
      fetchPricesChunkSize: 200,

      // Reprocessed items input/data/display variables
      inputRITextArea: "",
      reprocessedItems: {},
      RIFields: [
        { key: "img", label: "" },
        { key: "name", label: "Item", sortable: true },
        { key: "quantity", label: "Quantity", sortable: true },
        { key: "price", label: "Unit Market Price", sortable: true },
        { key: "mValue", label: "Market Value", sortable: true },
        { key: "rValue", label: "Reprocessed Value", sortable: true },
        {
          key: "cachedTotalVolume",
          label: "Total Volume",
          sortable: true,
        },
        { key: "actions", label: "Actions" },
      ],
      RISortBy: "",
      RISortDesc: false,
      RISortDirection: "asc",

      //Expected Reprocessed Materials data/display variables
      expectedRM: {},
      RMFields: [
        { key: "img", label: "" },
        { key: "name", label: "Item", sortable: true },
        { key: "price", label: "Unit Price", sortable: true },
        {
          key: "cachedQuantity",
          label: "Quantity",
          sortable: true,
        },
        {
          key: "cachedTotalPrice",
          label: "Total Price",
          sortable: true,
        },
        {
          key: "cachedTotalVolume",
          label: "Total Volume",
          sortable: true,
        },
      ],
      RMSortBy: "",
      RMSortDesc: false,
      RMSortDirection: "asc",

      // EVE SDE data
      reprocessingMaterialsList: [],
      invTypes: [],
      mapRegions: [],
      mapSystems: [],
    };
  },
  mounted() {
    const self = this;
    // Load EVE SDE files
    Papa.parse("/eve_resources_2023/invTypeMaterials.csv", {
      download: true,
      header: true,
      dynamicTyping: true,
      complete: function (results) {
        self.reprocessingMaterialsList = results.data;
        // console.log("Reprocessing materials list :", results);
      },
    });
    Papa.parse("/eve_resources_2023/invTypes.csv", {
      download: true,
      header: true,
      dynamicTyping: true,
      complete: function (results) {
        self.invTypes = results.data;
        // console.log("Types :", results);
      },
    });
    Papa.parse("/eve_resources_2023/mapRegions.csv", {
      download: true,
      header: true,
      dynamicTyping: true,
      complete: function (results) {
        self.mapRegions = results.data;
        // console.log("Map Regions :", results);
      },
    });
    Papa.parse("/eve_resources_2023/mapSolarSystems.csv", {
      download: true,
      header: true,
      dynamicTyping: true,
      complete: function (results) {
        self.mapSystems = results.data;
        // console.log("Map Solar Systems :", results);
      },
    });
  },
  computed: {
    totalRMPrice() {
      return Object.values(this.expectedRM)
        .map((x) => x.cachedTotalPrice)
        .reduce((a, b) => a + b, 0);
    },
    totalRICost() {
      return Object.values(this.reprocessedItems)
        .map((x) => x.price * x.quantity)
        .reduce((a, b) => a + b, 0);
    },
    totalResult() {
      return this.totalRMPrice - this.totalRICost;
    },
  },
  methods: {
    /**
     * Parse a localized number to a float.
     * @param {string} stringNumber - the localized number
     * @param {string} locale - [optional] the locale that the number is represented in. Omit this parameter to use the current locale.
     */
    parseLocaleNumber(stringNumber) {
      var thousandSeparator = ".";
      var decimalSeparator = ",";
      // console.log(thousandSeparator + decimalSeparator);
      return parseFloat(
        stringNumber
          .replace(new RegExp("\\" + thousandSeparator, "g"), "")
          .replace(new RegExp("\\" + decimalSeparator), ".")
      );
    },
    searchForItems() {
      this.loading = true;
      // retrieve reprocessed items list
      var lines = this.inputRITextArea.split("\n");
      var linesNotFound = [];
      // clear textarea
      this.inputRITextArea = "";
      // console.log(`Searching for : ${toSearch}`);

      lines.forEach((line) => {
        var toSearch = line.split("\t")[0];
        var amount = line.split("\t")[1];

        var itemResult = this.invTypes.filter(
          (x) => x.typeName === toSearch
        )[0];
        // console.log(`Item result : `, itemResult);

        if (itemResult !== undefined) {
          var recipe = this.reprocessingMaterialsList.filter(
            (x) => x.typeID === itemResult.typeID
          );
          // console.log("Recipe result : ", recipe);

          //store item found
          this.reprocessedItems[itemResult.typeID] = {
            typeID: itemResult.typeID,
            name: itemResult.typeName,
            volume: itemResult.volume,
            price: 0,
            batch: itemResult.portionSize,
            quantity: this.parseLocaleNumber(amount),
            recipe: {},
          };

          //if the recipe found has components
          if (recipe.length !== 0) {
            //go through every one
            for (var i = 0; i < recipe.length; i++) {
              var materialResult = this.invTypes.filter(
                (x) => x.typeID === recipe[i].materialTypeID
              )[0];
              // console.log(`Material result : `, materialResult);

              if (materialResult !== undefined) {
                // create a new entry of a reprocessed material or use previous entry
                this.expectedRM[materialResult.typeID] = {
                  ...{
                    typeID: materialResult.typeID,
                    name: materialResult.typeName,
                    volume: materialResult.volume,
                    price: 0,
                  },
                  ...this.expectedRM[materialResult.typeID],
                };
                //add the recipe of the quantity reprocessed
                this.reprocessedItems[itemResult.typeID].recipe[
                  materialResult.typeID
                ] = {
                  quantity: recipe[i].quantity,
                };
              }

              this.$forceUpdate();
            }
            //update cached quantities
            Object.keys(this.expectedRM).forEach((ermID) => {
              this.updateRMTotals(ermID);
            });
            //update Market and Reprocessed Values
            this.updateRITotals(itemResult.typeID);
          }
        } else {
          linesNotFound.push(line);
        }
      });

      if (linesNotFound.length > 0) {
        console.error("Did not find :", linesNotFound);
        this.inputRITextArea = linesNotFound.join("\n");
        // TODO show textarea as error / warning
      }
    },
    updateRMTotals(typeID) {
      const rm = this.expectedRM[typeID];

      if (rm === undefined) return;

      //go through every reprocessed item and add the estimated reprocessed amount if in the recipe
      var riToUpdate = [];
      rm.cachedQuantity = 0;

      Object.keys(this.reprocessedItems).forEach((riTypeID) => {
        const ri = this.reprocessedItems[riTypeID];

        if (ri.recipe[typeID] != undefined) {
          var ermRecipeQuantity = ri.recipe[typeID].quantity;
          riToUpdate.push(ri.typeID);

          rm.cachedQuantity +=
            Math.floor(ri.quantity / ri.batch) *
            ermRecipeQuantity *
            this.settings.rYield;
        }
      });

      rm.cachedTotalPrice = rm.price * rm.cachedQuantity;
      rm.cachedTotalVolume = rm.volume * rm.cachedQuantity;

      riToUpdate.forEach((id) => {
        this.updateRITotals(id);
      });

      this._computedWatchers.totalRMPrice.run();
      this._computedWatchers.totalResult.run();
      this.$forceUpdate();
    },
    updateRIQuantity(typeID) {
      const self = this;
      const ri = this.reprocessedItems[typeID];

      //for every recipe item update the cached Quantity
      //TODO optimize by only changing this reprocessed item quantity change in the RM cached quantity
      Object.keys(ri.recipe).forEach((itemID) => {
        self.updateRMTotals(itemID);
      });
    },
    updateRITotals(typeID) {
      const self = this;
      const ri = this.reprocessedItems[typeID];
      // console.log(`${typeID} recipe has :`);

      ri.mValue = ri.price * ri.quantity; //market value
      ri.rValue =
        Object.keys(ri.recipe) //reprocessed value
          .map((itemID) => {
            // console.log(`${itemID} : `, self.expectedRM[itemID]);
            const ermRecipeQuantity = ri.recipe[itemID].quantity;

            var ermEstimatedQuantity =
              Math.floor(ri.quantity / ri.batch) *
              ermRecipeQuantity *
              self.settings.rYield;

            return ermEstimatedQuantity * self.expectedRM[itemID].price;
          })
          .reduce((a, b) => a + b, 0);

      if (ri.rValue < ri.mValue) {
        ri._rowVariant = "danger";
        // console.log(ri);
        // this.$refs.itemsList.refresh();
      } else {
        delete ri._rowVariant;
        // this.$refs.itemsList.refresh();
      }

      ri.cachedTotalVolume = ri.volume * ri.quantity;

      this._computedWatchers.totalRICost.run();
      this._computedWatchers.totalResult.run();
      this.$forceUpdate();
    },
    updateAllPrices() {
      const self = this;
      Object.keys(this.expectedRM).forEach((typeID) => {
        self.updateRMTotals(typeID);
      });
      Object.keys(this.reprocessedItems).forEach((typeID) => {
        self.updateRITotals(typeID);
      });
    },
    removeRI(typeID) {
      const self = this;

      var recipeIDs = Object.keys(this.reprocessedItems[typeID].recipe);

      delete this.reprocessedItems[typeID];

      recipeIDs.forEach((itemID) => {
        self.updateRMTotals(itemID);
      });

      this._computedWatchers.totalRMPrice.run();
      this._computedWatchers.totalRICost.run();
      this._computedWatchers.totalResult.run();
      this.$forceUpdate();
    },
    fetchPrices() {
      const self = this;
      console.log("Fetching prices for : ", self.settings)
      // fetch all different typeIDs from reprocessed items and expected reprocessed materials
      var typeIDs = [];
      Object.keys(this.reprocessedItems).forEach((x) => {
        typeIDs.push({ typeID: x, type: "ri" });
      });
      Object.keys(this.expectedRM).forEach((x) => {
        typeIDs.push({ typeID: x, type: "rm" });
      });

      // do by max chunks of 200
      for (let i = 0; i < typeIDs.length; i += this.fetchPricesChunkSize) {
        // get the next chunk of typeIds
        let chunk = typeIDs.slice(i, i + this.fetchPricesChunkSize);
        // convert to url parameter
        let typeIdsUrlStr = chunk.map((x) => x.typeID).join(",");

        // start to construct url with selected typeIds
        let getString = `https://market.fuzzwork.co.uk/aggregates/?types=${typeIdsUrlStr}`;

        // add region selected to query parameters
        if (this.settings.market_scope_choice == "region") {
          getString += `&region=${self.settings.market_region}`
        } else if (this.settings.market_scope_choice == "system") {
          getString += `&region=${self.settings.market_system}`;
        }

        // console.log("GET ", getString);
        axios
          .get(getString)
          .then((response) => {
            console.log("Response : ", response.data)

            Object.keys(response.data).forEach((marketTypeId) => {
              const marketData = response.data[marketTypeId];
              // console.log("Reintegrating market data : ", marketTypeId, marketData);
              console.log("Price per settings : ", marketData[self.settings.market_type][self.settings.market_price]);
              // retrieve location of the item (RM or RI)
              let item = typeIDs.filter((x) => x.typeID == marketTypeId)[0];
              // console.log("Item : ", item);

              if (item.type === "ri") {
                const ri = self.reprocessedItems[marketTypeId];

                // TODO reuse market data on settings change if applicable
                // TODO store market data
                // ri.marketData = marketData;

                // get price by settings
                ri.price =
                  marketData[self.settings.market_type][
                  self.settings.market_price
                  ];
                // console.log(ri);
                self.updateRITotals(item.typeID);
              } else if (item.type === "rm") {
                let rm = self.expectedRM[marketTypeId];

                // TODO reuse market data on settings change if applicable
                // TODO store market data
                // rm.marketData = marketData;

                // get price by settings
                rm.price =
                  marketData[self.settings.market_type][
                  self.settings.market_price
                  ];

                self.updateRMTotals(item.typeID);
              }
            });
          })
          .catch((ex) => {
            // TODO error catching
            console.error(ex);
          });
      }
    },
    log(val) {
      console.log(val);
    },
    textAreaSpecialKeys(e) {
      if (e.key == "Tab") {
        e.preventDefault();

        var start = e.target.selectionStart;
        var end = e.target.selectionEnd;

        // set textarea value to: text before caret + tab + text after caret
        e.target.value =
          e.target.value.substring(0, start) +
          "\t" +
          e.target.value.substring(end);

        // put caret at right position again
        e.target.selectionStart = e.target.selectionEnd = start + 1;
      }
    },
  },
};
</script>

<style>
.reprocessed-list {
  list-style-type: none;
}

.table-header {
  text-align: center;
  width: 10rem;
}

.table th {
  padding: 0.5rem !important;
  vertical-align: middle !important;
}

.table td {
  padding: 0 0.25rem !important;
  vertical-align: middle !important;
}

.align-right {
  text-align: right;
}
</style>
